import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurantorderbooking',
  templateUrl: './restaurantorderbooking.component.html',
  styleUrls: ['./restaurantorderbooking.component.css']
})
export class RestaurantorderbookingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/app/restaurantorderbooking/restaurantorderbooking.component.ts